export default "__VITE_PUBLIC_ASSET__e868de6e__"